import * as React from 'react';
import { cn } from '@/lib/utils';

const Loader = React.forwardRef(({ className, ...props }, ref) => (
  <LoaderContainer>
    <div
      ref={ref}
      data-id="loader"
      className={cn(
        'border border-solid border-neutral-lighter w-[100px] h-3 rounded-full bg-gradient-to-br from-bright via-primary-lightest to-primary-lightest bg-[length:0%_100%] bg-left bg-no-repeat animate-progress relative',
        "after:content-'' after:absolute after:inset-0 after:rounded-full after:opacity-0 after:bg-[repeating-linear-gradient(-45deg,rgba(136,148,172,0)_0px,rgba(136,148,172,0)_10px,#8894AC_10px,#8894AC_20px)] after:bg-[length:0%_100%] after:bg-left after:bg-no-repeat after:animate-progress-fade",
        className
      )}
      {...props}
    />
  </LoaderContainer>
));
Loader.displayName = 'Loader';

const LoaderContainer = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    data-id="loader-container"
    className={cn('bg-transparent min-h-[40px] w-full flex items-center justify-center animate-fade-in', className)}
    {...props}
  />
));
LoaderContainer.displayName = 'LoaderContainer';

const LoaderWrapper = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    data-id="loader-wrapper"
    className={cn('text-center flex flex-col items-center gap-5', className)}
    {...props}
  />
));
LoaderWrapper.displayName = 'LoaderWrapper';

const LoaderWrapperText = React.forwardRef(({ className, ...props }, ref) => (
  <p
    ref={ref}
    data-id="loader-wrapper-text"
    className={cn('mb-0 text-neutral-darker text-base font-bold leading-tight', className)}
    {...props}
  />
));
LoaderWrapperText.displayName = 'LoaderWrapperText';

const LoaderSpinner = React.forwardRef(({ text = 'Gerando o relatório', className, ...props }, ref) => (
  <LoaderWrapper>
    {text && <LoaderWrapperText>{text}</LoaderWrapperText>}
    <div
      ref={ref}
      data-id="loader-spinner"
      className={cn('w-8 aspect-square rounded-full [-webkit-mask:radial-gradient(farthest-side,transparent_calc(100%-4px),#000_0)] animate-spinner', className)}
      style={{ background: 'radial-gradient(farthest-side,#8894AC 94%,#0000) top/4px 4px no-repeat, conic-gradient(#0000 30%,#8894AC)' }}
      {...props}
    />
  </LoaderWrapper>
));
LoaderSpinner.displayName = 'LoaderSpinner';

export { Loader, LoaderContainer, LoaderSpinner };
